import styled from 'styled-components';
import Colors from '../../constants/Colors';

const DashBg = styled.div`
  display: grid;
  height: 100%;
  overflow-x: scroll;
  background: ${Colors.darkBlueGray};
`;

export { DashBg };



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashUI.tsx